// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import AttributeLookupResourceViewModel from '../../../../viewModel/resource/AttributeLookupResourceViewModel';
import AttributeLookupResourceDTO from '../../dto/resource/AttributeLookupResourceDTO';

export default abstract class AttributeLookupResourceModel extends BaseModel<AttributeLookupResourceDTO> {
  /**
  * @type {uuid}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get caption() { return this.dto.caption; }
  set caption(value) { this.dto.caption = value; }
  /**
  */
  get details() { return this.dto.details; }
  set details(value) { this.dto.details = value; }
  /**
  * @type {int32}
  */
  get sort() { return this.dto.sort; }
  set sort(value) { this.dto.sort = value; }
  /**
  */
  get childKey() { return this.dto.childKey; }
  set childKey(value) { this.dto.childKey = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
    this.dto.caption = qs.caption;
    this.dto.details = qs.details;
    value = Number.parseFloat(qs.sort);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.sort = value;
    this.dto.childKey = qs.childkey;
  }
}
